module.exports = __webpack_public_path__ + "img/front buttons quantity.64e2e1b3.png";